import React from 'react';
import View from './View';
import adaptData from './adaptData';

const Results = ({ data, location }) => {
   return <View {...adaptData(data, location)} />;
};

export default Results;
